import Navbar from "@/components/feature/Navbar";
import HeroSection from "@/components/feature/HeroSection";
import FeaturesSection from "@/components/feature/FeaturesSection";
import TestimonialsSection from "@/components/feature/TestimonialsSection";
import AboutSection from "@/components/feature/AboutSection";
import VisitSection from "@/components/feature/VisitSection";
import Footer from "@/components/feature/Footer";

export default function Home() {
  return (
    <main className="min-h-screen">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <TestimonialsSection />
      <AboutSection />
      <VisitSection />
      <Footer />
    </main>
  );
}